export const WebCoreRoutes = [      //业务管理
    {
        path: '/Admin/WebCore/BIEvaluateManage',
        name: '测评管理',
        component: () => import('./BIEvaluateManage/index.vue'),
        meta: {
            title: '测评管理'
        }
    }, {
        path: '/Admin/WebCore/BIEvaluateManage/ScoreIndex',
        name: '成绩管理',
        component: () => import('./BIEvaluateManage/ScoreIndex.vue'),
        meta: {
            title: '成绩管理'
        }
    }, {
        path: '/Admin/WebCore/BIEvaluateManage/ScoreList',
        name: '测评成绩表',
        component: () => import('./BIEvaluateManage/ScoreList.vue'),
        meta: {
            title: '测评成绩表'
        }
    }, {
        path: '/Admin/WebCore/BIEvaluateManage/Edit',
        name: '成绩录入',
        component: () => import('./BIEvaluateManage/Edit.vue'),
        meta: {
            title: '成绩录入'
        }
    }, {
        path: '/Admin/WebCore/BIEvaluateManage/EnlistList',
        name: '报名详情',
        component: () => import('./BIEvaluateManage/EnlistList.vue'),
        meta: {
            title: '成绩录入'
        }
    }, {
        path: '/Admin/WebCore/BICourseManage',
        name: '课程管理',
        component: () => import('./BICourseManage/index.vue'),
        meta: {
            title: '课程管理'
        }
    }, {
        path: '/Admin/WebCore/BICourseManage/Edit',
        name: '修改课程信息',
        component: () => import('./BICourseManage/Edit'),
        meta: {
            title: '修改课程信息'
        }
    }, {
        path: '/Admin/WebCore/BICourseManage/users',
        name: '用户详情',
        component: () => import('./BICourseManage/users'),
        meta: {
            title: '用户详情'
        }
    }, {
        path: '/Admin/WebCore/BICourseManage/BatchCourse',
        name: '批量赠送',
        component: () => import('./BICourseManage/BatchCourse'),
        meta: {
            title: '批量赠送'
        }
    }, {
      path: '/Admin/WebCore/BIActivityManage',
      name: '活动管理',
      component: () => import('./BIActivityManage/index.vue'),
      meta: {
          title: '活动管理'
      }
  }, {
    path: '/Admin/WebCore/BIActivityManage/Detail',
    name: '活动报名详情',
    component: () => import('./BIActivityManage/Detail.vue'),
    meta: {
        title: '活动报名详情'
    }
  }, { // 作品管理页
    path: '/Admin/WebCore/BIWorksManage',
    name: '作品管理',
    component: () => import('./BIWorksManage/index.vue'),
    meta: {
        title: '作品管理'
    }
  },{ // 报名表管理
    path: '/Admin/WebCore/BIRegistration',
    name: '报名表管理',
    component: () => import('./BIRegistration/index.vue'),
    meta: {
        title: '报名表管理'
    }
  },{ // 报名表管理
    path: '/Admin/WebCore/BIAdminIstrators',
    name: '线下测评管理',
    component: () => import('./BIAdminIstrators/index.vue'),
    meta: {
        title: '线下测评管理'
    }
    },{
        path: '/src/pages/Admin/AdminHome/WebCore/BIAdminIstrators/Edit.vue',
        name: '新增专栏',
        component: () => import('./BIAdminIstrators/Edit.vue'),
        meta: {
            title: '线下测评管理'
        }
      },{
        path: '/src/pages/Admin/AdminHome/WebCore/BIAdminIstrators/Edit_1.vue',
        name: '新增分栏',
        component: () => import('./BIAdminIstrators/Edit_1.vue'),
        meta: {
            title: '线下测评管理'
        }
      },{
        path: '/src/pages/Admin/AdminHome/WebCore/BIAdminIstrators/indexArticle.vue',
        name: '分栏页面',
        component: () => import('./BIAdminIstrators/indexArticle.vue'),
        meta: {
            title: '线下测评管理'
        }
      },{ // 兑换码管理
        path: '/Admin/WebCore/redemptionCode',
        name: '兑换码管理',
        component: () => import('./redemptionCode/index.vue'),
        meta: {
            title: '兑换码管理'
        }
      },{ // 提现
        path: '/Admin/WebCore/withdrawal',
        name: '兑换码交易管理',
        component: () => import('./withdrawal/index.vue'),
        meta: {
            title: '兑换码交易管理'
        }
      },{
    path: '/Admin/WebCore/BIWorksManage/WorksManageDetail',
    name: '作品详情',
    component: () => import('./BIWorksManage/WorksManageDetail.vue'),
    meta: {
        title: '作品详情'
    }
  }, 
  
  // { // 评测任务页
  //   path: '/Admin/WebCore/BIEvaluateTask',
  //   name: '评测任务',
  //   component: () => import('./BIEvaluateTask/index.vue'),
  //   meta: {
  //       title: '评测任务'
  //   }
  // }, 
  // {
  //   path: '/Admin/WebCore/BIEvaluateTask/EvaluateTaskDetail',
  //   name: '任务详情',
  //   component: () => import('./BIEvaluateTask/EvaluateTaskDetail.vue'),
  //   meta: {
  //       title: '任务详情'
  //   }
  // }, 
  { // 评测结果页
    path: '/Admin/WebCore/BIEvaluateResult',
    name: '评测结果',
    component: () => import('./BIEvaluateResult/index.vue'),
    meta: {
        title: '评测结果'
    }
  }, {
    path: '/Admin/WebCore/BIEvaluateResult/EvaluateResultDetail',
    name: '结果详情',
    component: () => import('./BIEvaluateResult/EvaluateResultDetail.vue'),
    meta: {
        title: '结果详情'
    }
  },
  { // 订单管理页面
    path: '/Admin/WebCore/ORDerManagement',
    name: '订单管理',
    component: () => import('./ORDerManagement/index.vue'),
    meta: {
        title: '订单管理'
    }
  }, {
    path: '/Admin/WebCore/ORDerManagement/order',
    name: '订单详情',
    component: () => import('./ORDerManagement/order.vue'),
    meta: {
        title: '订单详情'
    }
  }, 
]



// WEBPACK FOOTER //
// ./src/pages/Admin/AdminHome/WebCore/routes.js